/*
NOTE: The Payer Setup Status radio group stores its value as a string because that is what a radio
input produces. The API expects a nullable boolean, and "Show All" must be omitted from the request
entirely so the stored procedures' @PayerSetupStatus parameter stays NULL. Returning undefined for
"Show All" lets axios drop the query key and lets JSON.stringify omit the property.
*/
export function ParsePayerSetupStatusFilter(value) {
  if (value === "true") {
    return true;
  }

  if (value === "false") {
    return false;
  }

  return undefined;
}
